import { Card, styled } from "@mui/material";
import { COLORS } from "assets";

const StyledCard = styled(Card)(() => ({
  backgroundColor: COLORS.surface.card,
  maxWidth: "100%",
  marginBottom: 8,
  borderRadius: COLORS.radius.md,
  boxShadow: COLORS.shadow.card,
  border: `1px solid ${COLORS.surface.border}`
}));

export default StyledCard;
